import styled from 'styled-components';

export const Message = styled.span`
  font-size: 22px;
  margin: 20px auto;
  color: ${props => props.color || 'white'};
  white-space: pre-wrap;
  word-wrap: break-word;
`


// WEBPACK FOOTER //
// ./src/components/message/index.js